import React, { useState } from 'react';
import { Icon } from '@iconify/react';

function Contact() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
        inquiryType: 'general'
    });

    const [volunteerData, setVolunteerData] = useState({
        name: '',
        email: '',
        phone: '',
        areaOfInterest: '',
        availability: '',
        location: '',
        skills: ''
    });

    const [submitted, setSubmitted] = useState(false);
    const [volunteerSubmitted, setVolunteerSubmitted] = useState(false);

    const handleContactSubmit = (e) => {
        e.preventDefault();
        console.log('Contact form submitted:', formData);
        setSubmitted(true);
        setTimeout(() => setSubmitted(false), 5000);
    };

    const handleVolunteerSubmit = (e) => {
        e.preventDefault();
        console.log('Volunteer form submitted:', volunteerData);
        setVolunteerSubmitted(true);
        setTimeout(() => setVolunteerSubmitted(false), 5000);
    };

    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleVolunteerChange = (e) => {
        setVolunteerData({
            ...volunteerData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <div className="contact-page">
            {/* Page Header */}
            <section className="page-header contact-header">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-8">
                            <h1 className="page-title animate-slide-up">Get In Touch</h1>
                            <p className="page-subtitle animate-slide-up delay-1">
                                Have questions? Want to get involved? We'd love to hear from you!
                            </p>
                        </div>
                        <div className="col-lg-4">
                            <div className="header-graphic animate-fade-in delay-2">
                                <Icon icon="material-symbols:contact-mail" className="header-icon" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Contact Info Cards */}
            <section className="contact-info-section">
                <div className="container">
                    <div className="row g-4">
                        <div className="col-lg-4 col-md-6">
                            <div className="contact-info-card">
                                <div className="info-icon">
                                    <Icon icon="mdi:map-marker" />
                                </div>
                                <h4>Our Office</h4>
                                <p>
                                    25 Yaounde Street,<br />
                                    Wuse Zone 6, Abuja
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="contact-info-card">
                                <div className="info-icon">
                                    <Icon icon="mdi:email" />
                                </div>
                                <h4>Email Us</h4>
                                <p>
                                    <a href="mailto:info@hsc-foundation.org">info@hsc-foundation.org</a><br />
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="contact-info-card">
                                <div className="info-icon">
                                    <Icon icon="mdi:phone" />
                                </div>
                                <h4>Call Us</h4>
                                <p>
                                    NG: <a href="tel:+234 (0) 706 1034 439">+234 (0) 706 1034 439</a><br />
                                    US: <a href="tel:+1 (857) 313 0950">+1 (857) 313 0950</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            {/* Contact Form & Volunteer Form */}
            <section className="forms-section">
                <div className="container">
                    <div className="row g-5">
                        {/* Contact Form */}
                        {/*
                        <div className="col-lg-6">
                        <div className="form-wrapper">
                            <div className="form-header">
                            <Icon icon="mdi:email-edit" className="form-header-icon" />
                            <h3>Send Us a Message</h3>
                            <p>Fill out the form below and we'll get back to you within 24-48 hours</p>
                            </div>

                            <form className="contact-form" onSubmit={handleContactSubmit}>
                            <div className="mb-3">
                                <label className="form-label">Full Name *</label>
                                <input
                                type="text"
                                className="form-control"
                                name="name"
                                value={formData.name}
                                onChange={handleInputChange}
                                required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Email Address *</label>
                                <input
                                type="email"
                                className="form-control"
                                name="email"
                                value={formData.email}
                                onChange={handleInputChange}
                                required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Phone Number</label>
                                <input
                                type="tel"
                                className="form-control"
                                name="phone"
                                value={formData.phone}
                                onChange={handleInputChange}
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Inquiry Type *</label>
                                <select
                                className="form-select"
                                name="inquiryType"
                                value={formData.inquiryType}
                                onChange={handleInputChange}
                                required
                                >
                                <option value="general">General Inquiry</option>
                                <option value="programs">Programs & Initiatives</option>
                                <option value="partnership">Partnership Opportunity</option>
                                <option value="donation">Donation Inquiry</option>
                                <option value="media">Media Request</option>
                                <option value="other">Other</option>
                                </select>
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Subject *</label>
                                <input
                                type="text"
                                className="form-control"
                                name="subject"
                                value={formData.subject}
                                onChange={handleInputChange}
                                required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Message *</label>
                                <textarea
                                className="form-control"
                                rows="5"
                                name="message"
                                value={formData.message}
                                onChange={handleInputChange}
                                required
                                ></textarea>
                            </div>

                            <button type="submit" className="btn btn-submit-form px-4">
                                <Icon icon="mdi:send" className="me-2" />
                                Send Message
                            </button>

                            {submitted && (
                                <div className="form-success">
                                <Icon icon="mdi:check-circle" className="me-2" />
                                Thank you! We'll get back to you soon.
                                </div>
                            )}
                            </form>
                        </div>
                        </div>
                        */}

                        {/* Volunteer Form */}
                        {/*
                        <div className="col-lg-6">
                        <div className="form-wrapper">
                            <div className="form-header">
                            <Icon icon="mdi:hand-heart" className="form-header-icon" />
                            <h3>Volunteer With Us</h3>
                            <p>Join our team of passionate volunteers making a difference</p>
                            </div>

                            <form className="volunteer-form" onSubmit={handleVolunteerSubmit}>
                            <div className="mb-3">
                                <label className="form-label">Full Name *</label>
                                <input
                                type="text"
                                className="form-control"
                                name="name"
                                value={volunteerData.name}
                                onChange={handleVolunteerChange}
                                required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Email Address *</label>
                                <input
                                type="email"
                                className="form-control"
                                name="email"
                                value={volunteerData.email}
                                onChange={handleVolunteerChange}
                                required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Phone Number *</label>
                                <input
                                type="tel"
                                className="form-control"
                                name="phone"
                                value={volunteerData.phone}
                                onChange={handleVolunteerChange}
                                required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Location/City *</label>
                                <input
                                type="text"
                                className="form-control"
                                name="location"
                                value={volunteerData.location}
                                onChange={handleVolunteerChange}
                                required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Area of Interest *</label>
                                <select
                                className="form-select"
                                name="areaOfInterest"
                                value={volunteerData.areaOfInterest}
                                onChange={handleVolunteerChange}
                                required
                                >
                                <option value="">Select an area</option>
                                <option value="education">Education Programs</option>
                                <option value="healthcare">Healthcare Initiatives</option>
                                <option value="community">Community Outreach</option>
                                <option value="research">Research & Data</option>
                                <option value="communications">Communications & Marketing</option>
                                <option value="fundraising">Fundraising</option>
                                <option value="events">Event Planning</option>
                                <option value="other">Other</option>
                                </select>
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Availability *</label>
                                <select
                                className="form-select"
                                name="availability"
                                value={volunteerData.availability}
                                onChange={handleVolunteerChange}
                                required
                                >
                                <option value="">Select availability</option>
                                <option value="weekdays">Weekdays</option>
                                <option value="weekends">Weekends</option>
                                <option value="flexible">Flexible</option>
                                <option value="remote">Remote Only</option>
                                </select>
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Relevant Skills/Experience</label>
                                <textarea
                                className="form-control"
                                rows="4"
                                name="skills"
                                value={volunteerData.skills}
                                onChange={handleVolunteerChange}
                                placeholder="Tell us about your skills, experience, and why you want to volunteer"
                                ></textarea>
                            </div>

                            <button type="submit" className="btn btn-submit-form px-4">
                                <Icon icon="mdi:hand-heart" className="me-2" />
                                Submit Application
                            </button>

                            {volunteerSubmitted && (
                                <div className="form-success">
                                <Icon icon="mdi:check-circle" className="me-2" />
                                Thank you for your interest! We'll be in touch soon.
                                </div>
                            )}
                            </form>
                        </div>
                        </div>
                        */}
                    </div>
                </div>
            </section>

            {/* Map Section */}
            <section className="map-section">
                <div className="container">
                    <div className="section-header text-center">
                        <span className="section-label">Visit Us</span>
                        <h2 className="section-title">Find Our Office</h2>
                    </div>
                    <center>
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4673.517616604691!2d7.450431975691518!3d9.071611788319172!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x104e0ad8e826ccb7%3A0xa133ae980972fea0!2s25%20Yaounde%20St%2C%20Zone%206%2C%20Abuja%20904101%2C%20Federal%20Capital%20Territory!5e1!3m2!1sen!2sng!4v1762959399751!5m2!1sen!2sng"
                            width="800"
                            height="600"
                            style={{ border: 0 }}
                            allowFullScreen
                            loading="lazy"
                            className='mt-5'
                            referrerPolicy="no-referrer-when-downgrade"
                        />
                    </center>
                </div>
            </section>

            {/* Office Hours */}
            <section className="office-hours-section">
                <div className="container">
                    <div className="office-hours-card">
                        <div className="row align-items-center">
                            <div className="col-lg-7 my-4 px-3">
                                <h3>Office Hours</h3>
                                <div className="hours-list">
                                    <div className="hours-item">
                                        <span className="day">Monday - Friday</span>
                                        <span className="time">9:00 AM - 5:00 PM</span>
                                    </div>
                                    <div className="hours-item">
                                        <span className="day">Saturday</span>
                                        <span className="time">10:00 AM - 2:00 PM</span>
                                    </div>
                                    <div className="hours-item">
                                        <span className="day">Sunday</span>
                                        <span className="time">Closed</span>
                                    </div>
                                </div>
                            </div>
                            {/*
                            <div className="col-lg-5 my-4 px-4">
                                <h3>Connect With Us</h3>
                                <div className="row justify-content-between">
                                <div className='col-auto'>
                                    <a href="#" className="social-btn facebook my-2">
                                    <Icon icon="mdi:facebook" />
                                    <span>Facebook</span>
                                    </a>
                                </div>
                                <div className='col-auto'>
                                    <a href="#" className="social-btn twitter my-2">
                                    <Icon icon="mdi:twitter" />
                                    <span>Twitter</span>
                                    </a>
                                </div>
                                <div className='col-auto'>
                                    <a href="#" className="social-btn linkedin my-2">
                                    <Icon icon="mdi:linkedin" />
                                    <span>LinkedIn</span>
                                    </a>
                                </div>
                                <div className='col-auto'>
                                    <a href="#" className="social-btn instagram my-2">
                                    <Icon icon="mdi:instagram" />
                                    <span>Instagram</span>
                                    </a>
                                </div>
                                </div>
                            </div>
                            */}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Contact;
